import React from 'react';
import styles from '@/styles/components/ErrorModal.module.css';
import { ActionButton } from '@ax2/common/components/ActionButton';
import crossIcon from '@ax2/common/assets/cross_blue.svg';
import { RemoveScroll } from 'react-remove-scroll';
import _ from 'lodash';

export interface ErrorModalData {
  errorText: string;
  actions?: { text: string; onClick: () => void }[];
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalData> = props => {
  return (
    <RemoveScroll>
      <div className={styles.container}>
        <div className={styles.background} onClick={props.onClose} />
        <div className={styles.contentWrapper}>
          <>
            <div className={styles.content}>
              <span className={styles.errorText}>{props.errorText}</span>
              <div className={styles.actions}>
                {_.map(props.actions, (a, index) => (
                  <ActionButton
                    key={index}
                    type="primary"
                    text={a.text}
                    onClick={() => {
                      props.onClose();
                      a.onClick();
                    }}
                  />
                ))}
              </div>
            </div>
            <span className={styles.close}>
              <ActionButton
                type="icon"
                icon={{
                  source: crossIcon,
                  size: 'large',
                }}
                onClick={props.onClose}
              />
            </span>
          </>
        </div>
      </div>
    </RemoveScroll>
  );
};

export default ErrorModal;
